import { render, staticRenderFns } from "./OverviewPkh.vue?vue&type=template&id=105b546a&"
import script from "./OverviewPkh.vue?vue&type=script&lang=js&"
export * from "./OverviewPkh.vue?vue&type=script&lang=js&"
import style0 from "./OverviewPkh.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports